import classes from "./SolutionTile.module.scss";
import { Card } from "primereact/card";
import { ISolutionOption } from "./Solutions";
import UsersService from "@velocity-ehs/user-utils-module";
import { useTranslation } from "react-i18next";
import { useFlags } from "launchdarkly-react-client-sdk";

interface ISolutionTile {
  solution: ISolutionOption;
}

export const SolutionTile: React.FC<ISolutionTile> = ({ solution }) => {
  const { t } = useTranslation();
  const { enableTranslationsAPI } = useFlags();

  const openSolutionNav = () => {
    UsersService.publish("TILE_CLICK", { solutionId: solution.id });
  };

  return (
    <Card className={classes.solutionTile} onClick={openSolutionNav}>
      <div className={classes.tileContentContainer}>
        <div className={classes.iconContainer}>
          <i className={solution.icon}></i>
        </div>
        <div className={classes.label}>
          <span>
            {enableTranslationsAPI
              ? t(`Solution_${solution.nameToken}`)
              : solution.label}
          </span>
        </div>
      </div>
    </Card>
  );
};

export default SolutionTile;
